import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { NumberField } from "@components/molecules";
import { commonMessages } from "../../intl";
export var QuantityTextField = function QuantityTextField(_ref) {
  var disabled = _ref.disabled,
      quantity = _ref.quantity,
      maxQuantity = _ref.maxQuantity,
      onQuantityChange = _ref.onQuantityChange,
      hideErrors = _ref.hideErrors,
      errors = _ref.errors;
  var intl = useIntl();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTooMuch = _useState2[0],
      setIsTooMuch = _useState2[1];

  useEffect(function () {
    setIsTooMuch(!Number.isNaN(quantity) && quantity > maxQuantity);
  }, [quantity, maxQuantity]);

  var handleQuantityChange = function handleQuantityChange(newQuantity) {
    if (newQuantity < 0) {
      return;
    }

    if (quantity !== newQuantity) {
      onQuantityChange(newQuantity);
    }

    setIsTooMuch(!Number.isNaN(newQuantity) && newQuantity > maxQuantity);
  };

  var quantityErrors = !hideErrors && isTooMuch ? [{
    message: intl.formatMessage(commonMessages.maxQtyIs, {
      maxQuantity: maxQuantity || ""
    })
  }] : [];
  return React.createElement(NumberField, {
    value: quantity,
    disabled: disabled,
    onChange: handleQuantityChange,
    errors: quantityErrors.concat(errors)
  });
};